const $ = require('jquery');

class MemoScrollService {
    constructor($timeout) {
        this.$timeout = $timeout;
        this.scrollPositions = {};
        this.previousUrl = '';
        this.currentUrl = '';
    }

    /**
     * Restores a scroll position saved under the given name to the element. If no element is provided,
     * the scroll position is restored to the document.
     * @param {String} name - The name under which the scroll position was saved.
     * @param {(Element|jQuery|String)} [element=document] - The element which the scroll position should be restored to.
     */
    restoreScrollPosition(name, element) {
        const $el = $(element || document);

        if (name in this.scrollPositions) {
            this.$timeout(() => {
                $el.scrollTop(this.scrollPositions[name]);
                this.forgetScrollPosition(name);
            }, 100, false);
        } else {
            $el.scrollTop(0);
        }
    }

    /**
     * Remembers the scroll position of a given element.
     * @param {String} name - The name under which to save the scroll position.
     * @param {(Element|jQuery|String)} [element=document] - The element from which the scroll position should be fetched.
     */
    rememberScrollPosition(name, element) {
        const $el = $(element || document);

        if ($el.scrollTop() > 0) {
            this.scrollPositions[name] = $el.scrollTop() > $(window).height()
                ? $el.scrollTop() - $(window).height()
                : $el.scrollTop();
        }
    }

    /**
     * Forgets the scroll position for a given memo.
     * @param {String} name  - The name of the memo to forget.
     * @returns {Boolean}
     */
    forgetScrollPosition(name) {
        return delete this.scrollPositions[name];
    }
}

module.exports = MemoScrollService;



// WEBPACK FOOTER //
// ./src/olycommon/memoscroll/memoscroll.service.js